import { useMemo, useState } from "react"
import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "@/pages/sales-return/Columns"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import SalesReturnModal from "./SalesReturnModal"
import { CrudProvider, useCrudContext } from "@/context/crudContext"
import {
  SalesReturnCrudProvider,
  useSalesReturnCrudContext,
} from "@/context/salesReturnCrudContext"
import { useNavigate } from "react-router-dom"
import { isAdminPortal } from "@/utilities/domain"
import {
  ReportBranchFilter,
  ReportBranchProvider,
  useReportBranch,
  withBranchColumn,
} from "@/components/Reports/ReportBranchFilter"

const adminColumns = withBranchColumn(columns)

export default function SalesReturnList() {
  return (
    <>
      <div className="breadcrumb-card">
        <h5>Sales Return</h5>
      </div>

      {isAdminPortal() ? (
        <ReportBranchProvider>
          <AdminSalesReturnTable />
        </ReportBranchProvider>
      ) : (
        <SalesReturnCrudProvider>
          <SalesReturnTable />
        </SalesReturnCrudProvider>
      )}
    </>
  )
}

function SalesReturnTable() {
  const {
    openSalesReturnDialog,
    setOpenSalesReturnDialog,
    setSelectedSalesReturnRow,
  } = useSalesReturnCrudContext()

  const navigate = useNavigate()

  return (
    <>
      <CustomTable
        label="Sales Return"
        columns={columns}
        apiPath="sales-return"
        onAdd={() => setOpenSalesReturnDialog(true)}
        onView={(rowData) => {
          navigate(`/pos/sales/${rowData.order_id}`)
        }}
        showEdit={false}
        showDelete={false}
      />

      {openSalesReturnDialog ? <SalesReturnModal /> : null}
    </>
  )
}

// Company administrators review every branch's returns, or a selected one;
// returns are processed on the branch portals.
function AdminSalesReturnTable() {
  const navigate = useNavigate()
  const { branchId } = useReportBranch()
  const branchFilter = useMemo(() => ({ branch_id: branchId }), [branchId])

  return (
    <CustomTable
      label="Sales Return"
      columns={adminColumns}
      apiPath="sales-return"
      addBtn={false}
      showEdit={false}
      showDelete={false}
      onView={(rowData) => navigate(`/pos/sales/${rowData.order_id}`)}
      hardcodedFilters={branchFilter}
      renderFilters={() => <ReportBranchFilter sx={{ mb: 0 }} />}
    />
  )
}
